/* import __COLOCATED_TEMPLATE__ from './alert-modal.hbs'; */
import { computed } from '@ember/object';
import Component from '@ember/component';
import { inject as service } from '@ember/service';

/**
## Alert Modal

Simple modal that shows a title, message, and OK button.
Returns a promise resolves to true when the OK button or <enter> key
is pressed.

## Example (Using Modal Service) - The preferred method

```javascript
modal: Ember.inject.service(),

actions: {
  delete() {
    this.modal.open(ModalsAlertModal, {
      titleText: "You can't do this",
      bodyText: "This is why you can't do this",
    }).then(() => keepCalmAndCarryOn());
  }
}
```

```example
@title Example (Rendering Template)

@hbs
{{#toggle-code-example exampleName="Alert Modal" show=showModal}}
  {{modals/alert-modal modalOptions=modalOptions
                       close=(action (mut showModal) false)}}
{{/toggle-code-example}}

@controller-properties
{
  modalOptions: {
    titleText: "You can't do this",
    bodyText: "This is why you can't do this",
    okButtonText: "OK"
  }
}
```

@param {Object} modalOptions
@param {String} modalOptions.titleText - Localized modal title.
@param {String} modalOptions.bodyText - Localized modal body.
@param {String} modalOptions.okButtonText - OK button label, defaults to "OK".
@param {Action} close - An action to run to close the modal (provided for you if you use the modal service)

*/

// eslint-disable-next-line ember/no-classic-classes
export default Component.extend({
  i18n: service(),
  okLabel: computed('i18n', 'modalOptions.okButtonText', function () {
    return this.modalOptions.okButtonText || this.i18n.t('button.ok');
  })
});